"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarkAsReadOption_1 = require("owa-mark-as-read-option/lib/MarkAsReadOption");
var ReplyOption_1 = require("owa-reply-option/lib/ReplyOption");
var MessageOption_1 = require("owa-message-option/lib/MessageOption");
var ReadReceiptsOption_1 = require("owa-read-receipts-option/lib/ReadReceiptsOption");
var handlingSubCategory = {
    key: 'handling',
    titleStringKey: 'optionSubcategory_handling',
    options: [MarkAsReadOption_1.default, ReplyOption_1.default, MessageOption_1.default, ReadReceiptsOption_1.default],
};
exports.default = handlingSubCategory;
//# sourceMappingURL=handlingSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/handlingSubCategory.js
// module id = 5039
// module chunks = 2